<template>
  <MobileGoogleAdsPopup
    path="/22163595876/RTBGo_Web_Mobile_320x250"
    :size="[320, 250]"
    id="RTBGo_Web_Mobile"
    style="margin:0 auto;"
  />
</template>

<script>
import MobileGoogleAdsPopup from "../../../popup/mobileGoogleAdsPopup.vue";
export default {
  data() {
    return {};
  },
  components: {
    MobileGoogleAdsPopup,
  },
};
</script>

<style scoped></style>
